module.exports = __webpack_public_path__ + "img/team-julia.20894f93.jpg";